import {
  IServiceType,
  IServiceTypeData,
  IServiceTypeSimple,
  IServiceTypeSimpleData,
  SERVICE_TYPE_NAME_MAX_LENGTH
} from './index'
import {
  IServiceTypePrice,
  IServiceTypePriceData,
  ServiceTypePrice,
  ServiceChoice
} from '../index'


export class ServiceTypeSimple implements IServiceTypeSimple {
  readonly id?: number
  readonly type: ServiceChoice
  name: string
  description?: string
  note?: string

  constructor(data?: IServiceTypeSimpleData) {
    this.id = data?.id
    this.type = data?.type || 'consultation'
    this.name = data?.name || 'Service'
    this.description = data?.description
    this.note = data?.note
  }

  validate(): boolean {
    return this.validateName()
  }

  validateName(): boolean {
    let name = this.name
    return !!name && name.length <= SERVICE_TYPE_NAME_MAX_LENGTH
  }

  update(data?: IServiceTypeSimpleData): void {
    this.name = data?.name || this.name
    this.description = data?.description || this.description
    this.note = data?.note || this.note
  }

  get key(): string {
    let id = this.id;
    return this.name + (id ? ('-' + id) : '');
  }
}


export class ServiceType extends ServiceTypeSimple implements IServiceType {
  special?: string
  prices: IServiceTypePrice[]

  constructor(data?: IServiceTypeData) {
    super(data)
    this.special = data?.special
    let prices = data?.prices
    this.prices = prices ? prices.map((price: IServiceTypePriceData) => new ServiceTypePrice(price)) : []
  }

  validate(): boolean {
    return super.validate();
  }

  update(data?: IServiceTypeData): void {
    super.update(data)
    this.special = data?.special || this.special
  }
}
